import React from 'react';
import {
  Container,
  AvatarWrapper,
  RecipientName,
  ReceivingMethodWrapper,
  AccountNumber,
  PaymentLabel,
  Wrapper
} from './Styles';
import { CommonButton, InstaremAvatar } from '@Components';
import ReceivingMethodInfoCard from './components/ReceivingMethodInfoCard';
import { useDispatch, useSelector } from 'react-redux';
import { getUserFlowReducer, selectNewBeneState, selectUserStatusReducer } from '@Redux/selectors';
import { PIGGY_BANK_ICON } from '@Images';
import { payoutMethodInfo } from '../receiving-method/utils/constants';
import { getPayoutVars } from '../../layout/utils/methods';
import withRouterV6 from '../../../../components/common/withRouterV6';
import { RecipientAddedProps } from './utils/types';
import { INDIVIDUAL, MULTIPLE_TRANSACTION_URL, TRANSFER_MONEY_URL } from '@Utils/constants';
import { AppDispatch, UserFlowReducer, UserStatusReducer } from '../../../../store.type';
import { changeScreen } from '@Redux/actions/user-flow';
import { USER_FLOW_JUMP_TO } from '@Redux/action-contants';

const RecipientAdded: React.FC<RecipientAddedProps> = (props) => {
  const {
    parentState: { isRedirectedFromSendMoney },
    navigate
  } = props;
  const { formValues, payoutLabel, isBeneSchemaEnabled } = useSelector(selectNewBeneState);
  const { timeline, screens } = useSelector(getUserFlowReducer) as UserFlowReducer;
  const { account_type: userAccountType = INDIVIDUAL } = useSelector(
    selectUserStatusReducer
  ) as UserStatusReducer;
  const dispatch = useDispatch<AppDispatch>();

  const { paymentLabel, accountNumber, payoutLabelforNonBeneSchema } = getPayoutVars(
    formValues,
    payoutLabel
  );
  const showPaymentLabel = isBeneSchemaEnabled ? payoutLabel : payoutLabelforNonBeneSchema;

  const handleUserRedirection = () => {
    if (userAccountType !== INDIVIDUAL) {
      navigate(MULTIPLE_TRANSACTION_URL);
      return;
    }

    if (isRedirectedFromSendMoney) {
      dispatch(changeScreen(USER_FLOW_JUMP_TO, 'send_money', screens, timeline));
    } else {
      navigate(TRANSFER_MONEY_URL);
    }
  };

  return (
    <div className="child-component-container__content-container">
      <Container>
        <AvatarWrapper>
          <InstaremAvatar
            name={formValues?.beneficiary_name || formValues?.company_name}
            flagCode={formValues?.bank_account_country}
          />
          <RecipientName>{formValues?.beneficiary_name || formValues?.company_name}</RecipientName>
        </AvatarWrapper>
        <ReceivingMethodWrapper>
          <div className="receiving-method-section">
            <span className="receiving-method-title">Receiving method</span>
            <ReceivingMethodInfoCard
              icon={
                payoutMethodInfo[formValues?.payout_method?.toUpperCase()]?.image ?? PIGGY_BANK_ICON
              }
              title={showPaymentLabel}
              subtitle={
                <Wrapper>
                  <PaymentLabel>{paymentLabel}</PaymentLabel>
                  {accountNumber && <AccountNumber> {accountNumber}</AccountNumber>}
                </Wrapper>
              }
            />
          </div>
          <CommonButton text="Send money" width={'100%'} onClick={handleUserRedirection} />
        </ReceivingMethodWrapper>
      </Container>
    </div>
  );
};

export default withRouterV6(RecipientAdded);
